/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';
import _chunk from 'lodash/chunk';

import {Link} from 'react-router';
import {VelocityComponent} from 'velocity-react';
import ClassNames from 'classnames';

import {SetSettingsState, CloseAllProfiles} from '../../actions/common/actions-common';
import {GetFavorites} from '../../actions/favorites/actions-favorites';

import {StubFunc, urlRegExp, parseAppUrl} from '../../utils';

import Translate from '../../components/Translate/translate';

class Nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: '',
      searchIsActive: false,
      main_menu: [],
      showHiddenMenu: false,
      hidden_menu: []
    }
  }

  static contextTypes = {
    router: PropTypes.object
  };

  componentDidMount() {
    //TODO: replace this to middleware

    lh.common.events.on(lh.common.events.EVENT_OPEN_CONNECTION, () => {
      this.props.GetFavorites();
    });

    lh.common.events.on(lh.common.events.EVENT_CLOSE_CONNECTION, () => {
      //this.props.GetFavorites();
    });
  }

  componentWillReceiveProps() {
    let main_menu = [];
    let hidden_menu = [];

    if (this.props.menu[0].length > _get(Config, 'menu_length', 5)) {

      let menu = _chunk(this.props.menu[0], _get(Config, 'menu_length', 5) - 1);

      main_menu = menu[0];
      hidden_menu = menu[1];
    } else {

      main_menu = this.props.menu[0];
    }

    this.setState({
      main_menu: main_menu,
      hidden_menu: hidden_menu
    });
  }

  _toggleSearch(event) {

    this.setState({searchIsActive: !this.state.searchIsActive});

    if (this.state.searchIsActive) {

      setTimeout(() => {
        this._onSearchTermSubmit();
      }, 350);
    } else {
      this.setState({searchTerm: ''});

      setTimeout(() => {
        document.getElementById('simple-search').focus();
      }, 350);
    }
  }

  _onSearchTermChange(event = {}) {

    this.setState({searchTerm: _get(event, 'target.value', '')});
  }

  _onSearchTermKeyPressed(event = {}) {

    if (_get(event, 'nativeEvent.keyCode') === 27) {
      this.setState({searchIsActive: false});
    }
  }

  _onSearchTermSubmit(event = {}) {
    if (event.preventDefault) event.preventDefault();

    this.setState({searchIsActive: false});
    if (this.state.searchTerm) this.context.router.push('search/' + this.state.searchTerm);
  }

  _onSettingsOpen() {

    this.props.SetSettingsState({
      isShown: true,
      tabId: 'language'
    });
  }

  _onShowMoreItems() {

    this.setState({
      showHiddenMenu: !this.state.showHiddenMenu
    });
  }

  _renderMenu() {

    let menuNodes = this.state.main_menu.map((item, index) => {
      let isExternal = urlRegExp.test(item.app_url);

      let node = '';

      if (isExternal) {
        node = <a key={'menu_item_' + index} className="item" href={item.app_url} target="_blank" rel="noopener noreferrer">
          { item.icon && <img className="item-img" src={item.icon} alt="" /> }
          {item.title}
        </a>;
      } else {
        node = <Link key={'menu_item_' + index} className="item" to={{pathname: parseAppUrl(item.app_url, this.props.categories), state: {title: item.title, icon: item.icon}}}
                     onClick={this.props.CloseAllProfiles.bind(this)}>
          { item.icon && <img className="item-img" src={item.icon} alt="" /> }
          { item.title[0] === '$' ? <Translate content={item.title.replace('$', '')} /> : item.title}
          { (parseAppUrl(item.app_url, this.props.categories) === '/favorites') && <span className="h-rmenu-count"> {this.props.favorites.length} </span> }
        </Link>;
      }

      return (node);
    });

    if (this.state.hidden_menu.length) {

      menuNodes.push(<a key={'menu_item_more'} className="item" href="javascript:void(0)" onClick={this._onShowMoreItems.bind(this)}>
        <img className="item-img" alt="more" src={`/images/menu/dots.png`} />
        <Translate content="more_menu_items" />
      </a>);
    }

    return menuNodes;
  };

  _renderHiddenMenu() {
    if (!this.state.hidden_menu.length) {

      return null;
    }

    let menuNodes = this.state.hidden_menu.map((item, index) => {
      let isExternal = urlRegExp.test(item.app_url);

      let node = '';

      if (isExternal) {
        node = <a key={'menu_item_' + index} className="item" href={item.app_url} target="_blank" rel="noopener noreferrer">
          { item.icon && <img className="item-img" src={item.icon} alt="" /> }
          {item.title}
        </a>;
      } else {
        node = <Link key={'menu_item_' + index} className="item" to={{pathname: parseAppUrl(item.app_url, this.props.categories), state: {title: item.title, icon: item.icon}}}
                     onClick={this.props.CloseAllProfiles.bind(this)}>
          { item.icon && <img className="item-img" src={item.icon} alt="" style={{width: '100%'}} /> }
          { item.title[0] === '$' ? <Translate content={item.title.replace('$', '')} /> : item.title}
          { (parseAppUrl(item.app_url, this.props.categories) === '/favorites') && <span className="h-rmenu-count"> {this.props.favorites.length} </span> }
        </Link>;
      }

      return (node);
    });

    return (<div className="ui inverted menu-top block bg-black radius hidden-menu"
                 style={{
                   opacity: this.state.showHiddenMenu ? 1 : 0,
                   display: this.state.showHiddenMenu ? 'block' : 'none'
                 }}>
      <ul className="h-rmenu menu-top block col-last">
        {menuNodes}
      </ul>
    </div>);
  };

  _renderTiledMenu() {

    return this.props.menu[1].map(function (item, index) {
      var isExternal = urlRegExp.test(item.app_url);
      return (
        <li key={'tiled_menu_item_' + index} className="h-rmenu-col block radius bg-black">
          {isExternal ?
            <a href={item.app_url} target="_blank" rel="noopener noreferrer">
              <img src={item.icon} style={{width: '100%'}} />
            </a>
            :
            <Link to={{pathname: parseAppUrl(item.app_url, this.props.categories), state: {title: item.title, icon: item.icon}}}>
              <img src={item.icon} alt={item.title} style={{width: '100%'}} />
              { (parseAppUrl(item.app_url, this.props.categories) === '/favorites') && <span className="h-rmenu-count"> {this.props.favorites.length} </span> }
            </Link>
          }
        </li>
      );
    }.bind(this));
  }

  render() {

    let searchFromClasses = ClassNames('h-rmenu-search-active', {'__active': this.state.searchIsActive});
    let searchTileClasses = ClassNames('h-rmenu-col block radius bg-black col-last', {'search-open': this.state.searchIsActive});

    return (
      <header className="site-header blocks-row clearfix">
        <div className="ui inverted menu-top block bg-black radius" style={{overflow: 'initial'}}>
          {this._renderHiddenMenu()}

          <div className="logo-container">
            <span className="operator-logo-helper"></span>
            <Link to="/" className="logo hover">
              <img className="operator-logo" src={Config.logo.img_url} alt="" />
            </Link>
          </div>
          {this._renderMenu()}
        </div>
        <ul className="h-rmenu menu-top block col-last">
          {this._renderTiledMenu()}
          <li className="h-rmenu-col block radius bg-black settings-open">
            <a href="javascript:void(0)" className="hover" onClick={this._onSettingsOpen.bind(this)}>
              <img src={_get(Config, 'additional_icons.settings', '/images/64x64/settings.png')} style={{width: '100%'}} />
            </a>
          </li>
          {_get(Config, 'isSearchAvailable', true) &&
           <VelocityComponent animation={{width: this.state.searchIsActive ? '268px' : '64px', marginLeft: this.state.searchIsActive ? '-67px' : 0}} duration={350}>
             <li className={searchTileClasses}>
               <a className="h-rmenu-search-link hover pointer" onClick={this._toggleSearch.bind(this)}>
                 <img src={_get(Config, 'additional_icons.search', '/images/64x64/search.png')} style={{width: '100%'}} />
               </a>
               <form className={searchFromClasses}
                     onSubmit={this._onSearchTermSubmit.bind(this)}>
                 <input autoFocus type="text" placeholder="Keywords" id="simple-search"
                        onKeyUp={this._onSearchTermKeyPressed.bind(this)}
                        onChange={this._onSearchTermChange.bind(this)}
                        value={this.state.searchTerm}
                 />
                 <a className="mw-show pad-lr hover">
                   <span className="block-note"></span>
                 </a>
               </form>
             </li>
           </VelocityComponent>
          }
        </ul>
      </header>
    );
  }
}

Nav.propTypes = {
  categories: PropTypes.array.isRequired,
  favorites: PropTypes.array.isRequired,
  menu: PropTypes.arrayOf(PropTypes.array).isRequired,
  GetFavorites: PropTypes.func
};

Nav.defaultProps = {
  menu: [[], []],
  GetFavorites: StubFunc.bind(this, 'GetFavorites'),
  SetSettingsState: StubFunc.bind(this, 'SetSettingsState')
};

const mapStateToProps = ({common: {categories}, favorites: {favorites}}) => ({
  categories: categories,
  favorites: [...favorites.collection]
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({GetFavorites, SetSettingsState, CloseAllProfiles}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Nav);



// WEBPACK FOOTER //
// ./src/containers/NavigationMenu/navigation-menu.js